import React, { useState, useEffect, useContext } from "react";
import { MaterialReactTable } from "material-react-table";
import { Box, Button, Typography } from "@mui/material";
import { UserContext, getCurrentToken } from "./context/UserContext";
import { useNavigate } from "react-router-dom";
import requests from "./base";
import swal from "sweetalert";




const Commodities = () => {
  const { signOut } = useContext(UserContext);
  const navigate = useNavigate();
   const [userType, setUserType] = useState("");
  const [loading, setLoading] = useState(true);
  const [vendorData, setVendorData] = useState([]);
  const [token, setToken] = useState("");

  useEffect(() => {
    const tokenResponse = getCurrentToken();
    if (!tokenResponse) {
      navigate("/login");
    } else {
      const userToken = tokenResponse.Data.Token;
      setToken(userToken);
      
      const userType = tokenResponse.Data.UserType;
       setUserType(userType);
        if (userType !== 1 && userType !== 2) {
      swal("Unauthorized", "You are not authorized to access this page.", "warning")
        .then(() => {
          navigate("/"); // or "/unauthorized"
        });
      return;
        }
        fetchVendorData(userToken);
    }
  }, []);

  const approveVendor = async (ID, Type) => {
    try {
      let endpoint = "";
  
      if (Type === "Product") {
        endpoint = `/ApproveproductbyId?ID=${ID}`;
      } else if (Type === "Service") {
        endpoint = `/approveservicebyId?ID=${ID}`;
      } else {
        swal("Error", "Unknown type for approval.", "error");
        return;
      }
  
      const response = await requests.post(endpoint);
      if (response?.ResponseCode === 1) {
        swal("Success", `${Type} approved successfully.`, "success");
        fetchVendorData(token);
      } else {
        swal("Failed", response?.ResponseMessage, "error");
      }
    } catch (error) {
      console.error("Approval error:", error);
      swal("Error", "An error occurred during approval.", "error");
    }
  };
  

  const fetchVendorData = async (userToken) => {
    try {
      const response = await requests.get("/GetVendorProductsAndServices");
      if (response?.Data) { 
        setVendorData(response.Data || []);
      } else {
        console.error("Error fetching vendors:", response.ResponseMessage);
      }
    } catch (error) {
      console.error("Fetch error:", error);
    } finally {
      setLoading(false);
    }
  };

  const columns = [
 
    {
      accessorKey: "ID",
      header: "ID",
    },

    
    {
        accessorKey: "Name",
        header: "Name",
      },

    {
      accessorKey: "VendorId",
      header: "Vendor Id",
    },
    {
      accessorKey: "Price",
      header: "Price",
    },
    {
        accessorKey: 'Status',
        header: 'Status',
        Cell: ({ cell }) => {
          const status = cell.getValue();
          const color = status === 'Active' ? 'green' : status === 'Inactive' ? 'red' : 'gray';
          return <span style={{ color }}>{status}</span>;
        },
    },
    {
      accessorKey: "Type",
      header: "Type",
      Cell: ({ cell }) => {
        const type = cell.getValue();
        const color =
          type === "Service"
            ? "#00253d"
            : type === "Product"
            ? "#f5821f"
            : "inherit";
        return <span style={{ color }}>{type}</span>;
      },
    },
    {
      accessorKey: "ID",
      header: "Actions",
      Cell: ({ row }) => (
        <Button
          variant="contained"
          color="success"
          size="small"
          onClick={() => approveVendor(row.original.ID, row.original.Type)}
        >
          Approve
        </Button>
      ),
    },
  ];

  if (loading) return <Typography>Loading...</Typography>;

  return (
    <Box className="container mt-4">
      <Box mt={3} p={2} borderRadius={2} boxShadow={4} border="1px solid #ccc">
      <MaterialReactTable
      columns={columns}
      data={vendorData}
      
    />
      </Box>
    </Box>
  );
};

export default Commodities;
